(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ridgetech-coming-soon-content"] && !Shopify.designMode) return;
  try {
    const serviceNames = {
  'truck-engine-rebuilding': 'Truck Engine Rebuilding',
  'detroit-series-60-performance': 'Detroit Series 60 & Performance',
  'truck-restoration-custom-builds': 'Truck Restoration & Custom Builds',
  'drivetrain-frame-modifications': 'Drivetrain & Frame Modifications',
  'custom-interiors-fabrication': 'Custom Interiors & Fabrication',
  'replacement-performance-parts': 'Replacement & Performance Parts',
  'build-gallery': 'Complete Build Gallery',
  'all-services': 'All Ridgetech Services'
};
const params = new URLSearchParams(window.location.search);
const selectedService = serviceNames[params.get('service')] || serviceNames['all-services'];
document.querySelectorAll('[data-service-title]').forEach((element) => {
  element.textContent = selectedService;
});
document.title = `${selectedService} | Service Details Coming Soon`;
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ridgetech-cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
  const banner = document.querySelector('[data-rt-cookie]');
  if (!banner) return;
  const storageKey = 'ridgetech-cookie-consent';
  const show = () => { banner.hidden = false; };
  const hide = () => { banner.hidden = true; };
  const updateGoogleConsent = (accepted) => {
    window.gtag?.('consent', 'update', {
      analytics_storage: accepted ? 'granted' : 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied'
    });
    if (accepted) window.ridgetechTrackPageView?.();
  };
  const record = (accepted) => {
    try { localStorage.setItem(storageKey, accepted ? 'accepted' : 'necessary'); } catch (error) {}
    updateGoogleConsent(accepted);
    const consent = { analytics: accepted, marketing: accepted, preferences: accepted };
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent(consent, hide);
    } else {
      hide();
    }
  };
  const initialize = () => {
    let choice = null;
    try { choice = localStorage.getItem(storageKey); } catch (error) {}
    if (choice === 'accepted') {
      updateGoogleConsent(true);
      hide();
      return;
    }
    if (choice === 'necessary') {
      updateGoogleConsent(false);
      hide();
      return;
    }
    const shopifyNeedsChoice = window.Shopify?.customerPrivacy?.shouldShowBanner?.();
    if (shopifyNeedsChoice === false) {
      updateGoogleConsent(true);
      hide();
      return;
    }
    show();
  };
  window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], initialize);
  if (!window.Shopify?.loadFeatures) initialize();
  banner.querySelector('[data-rt-cookie-accept]')?.addEventListener('click', () => record(true));
  banner.querySelector('[data-rt-cookie-reject]')?.addEventListener('click', () => record(false));
  document.addEventListener('click', (event) => {
    if (!event.target.closest?.('[data-rt-cookie-settings]')) return;
    event.preventDefault();
    show();
    banner.querySelector('button')?.focus();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ridgetech-site-controls"] && !Shopify.designMode) return;
  try {
    const setRidgetechMenuState = (menu, open) => {
    const trigger = menu.querySelector('summary');
    trigger?.setAttribute('aria-expanded', String(open));
    trigger?.setAttribute('aria-label', `${open ? 'Close' : 'Open'} the Ridgetech site menu`);
  };

  const closeRidgetechMenus = (restoreFocus = false) => {
    document.querySelectorAll('.rt-site-controls__menu[open]').forEach((menu) => {
      menu.removeAttribute('open');
      setRidgetechMenuState(menu, false);
      if (restoreFocus) menu.querySelector('summary')?.focus();
    });
  };

  document.querySelectorAll('.rt-site-controls__menu').forEach((menu) => {
    setRidgetechMenuState(menu, menu.open);
    menu.addEventListener('toggle', () => setRidgetechMenuState(menu, menu.open));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeRidgetechMenus(true);
  });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest?.('[data-rt-menu-close]');
    if (closeButton) {
      closeRidgetechMenus(true);
      return;
    }

    document.querySelectorAll('.rt-site-controls__menu[open]').forEach((menu) => {
      if (!menu.contains(event.target)) {
        menu.removeAttribute('open');
        setRidgetechMenuState(menu, false);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
